import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";

export const LiveCasinoGridItemBetIntervalDefaultBox = styled.div`
    position: absolute;
    top: 1em;
    left: 1em;
    padding: 0.5em 1em;
    line-height: 1;
    color: ${props => props.theme.colors.brandPrimary};
    background: ${props => hexToRgba(props.theme.colors.backgroundDark, 0.75)};
    border: 1px solid ${props => hexToRgba(props.theme.colors.backgroundContrast, 0.1)};
    border-radius: 50px;
    z-index: 3;

    > span {
        font-size: 1.2em;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        top: 0.5em;
        left: 0.5em;
        padding: 0.5em 1em;
    }
`;